import React from "react";

function ApplicationForm() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-xl flex flex-col items-center">
        <h1 className="text-3xl sm:text-4xl font-bold mb-8 text-gray-900 tracking-tight">Watch!</h1>
        <div className="w-full aspect-video bg-black rounded-2xl shadow-xl overflow-hidden border border-gray-200">
          <iframe
            src="https://drive.google.com/file/d/1rlTac9E0udsy0qieIos1IdvAqi10vofJ/preview"
            allow="autoplay"
            className="w-full h-full"
            frameBorder="0"
          ></iframe>
        </div>
        <p className="mt-8 text-center text-gray-600 text-lg max-w-lg">
          This page has changed! Watch the video above to learn how to apply for roles using the new process.
        </p>
      </div>
    </div>
  );
}

export default ApplicationForm;